export const MinimumPrice = ({ minimumPrice }: { minimumPrice: string }) =>
	!minimumPrice ? null : <span>{`Fra ${minimumPrice},- inkl. garn`}</span>;
